import { IApplicationState } from "../store/IApplicationState";
import { AppUtils } from "../utils/app-utils";

export const getCachedCreditCategories = (state: IApplicationState) => 
    !AppUtils.IsEmpty(state.accounting.creditCategories)
    ? state.accounting.creditCategories
    : null;

export const getCachedCreditReasons = (state: IApplicationState) => 
    !AppUtils.IsEmpty(state.accounting.creditReasons)
    ? state.accounting.creditReasons
    : null;    
